import { render } from "./CasesPage.vue?vue&type=template&id=bf6c4ec0&ts=true"
import script from "./CasesPage.vue?vue&type=script&lang=ts"
export * from "./CasesPage.vue?vue&type=script&lang=ts"

import "./CasesPage.vue?vue&type=style&index=0&id=bf6c4ec0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__